import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hero-carousel__slider"
}
const _hoisted_2 = { class: "swiper hero-carousel-slider" }
const _hoisted_3 = { class: "swiper-wrapper" }
const _hoisted_4 = { class: "swiper-slide" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hero_carousel_slide = _resolveComponent("hero-carousel-slide")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(['hero-carousel', $props.css])
  }, [
    ($props.slides.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.slides, (slide, i) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(), _createBlock(_component_hero_carousel_slide, {
                    slide: slide,
                    key: i
                  }, null, 8, ["slide"]))
                ]))
              }), 256))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}